export const gitVersion = 'eudr-recycled-1.0.13-470-ga876ff51';
